import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';
import { ChartType } from '@legacy-modules/metrics2/models/enumerations/ChartType';

export default new ValueExpression({
  identifier: 'zustellzeit_ht_netto',
  label: 'Netto-HT-Zeit',
  chart: ChartType.line,
  positiveDirection: PositiveDirection.custom,
  valueFormat: '#.###.##0,0 h',
  category: 'tours',
  definition: getDefinitionByName('Netto-HT-Zeit'),
  hidden: true,
  valueQuotient: 3600,
});
